// src/app/historico-record/mock/historico-record.mock.ts

export interface RegistroPuntoNota {
  materia: string;
  periodoAcademico: string;
  notaLabel:
    | 'Superior'
    | 'Satisfactorio'
    | 'En Desarrollo'
    | 'Insuficiente'
    | 'Aprobó'
    | 'No Aprobó'
    | 'Sin dato';
}

// Orden de periodos (ajusta si hace falta)
export const PERIODOS_ORDEN = [
  '2025-2026 I',
  '2024-2025 III',
  '2024-2025 II',
  '2024-2025 I',
  '2023-2024 IV',
  '2023-2024 III',
  '2023-2024 II',
  '2023-2024 I',
  '2022-2023 IV',
  '2022-2023 III',
  '2022-2023 II',
  '2022-2023 I',
];

// Orden de materias (ajústalo según tu realidad)
export const MATERIAS_ORDEN = [
  'Arte',
  'Catequesis del Buen Pastor',
  'Ciencias',
  'Comunicación',
  'Educación Física',
  'Español',
  'Global citizenship',
  'Inglés',
  'Matemáticas',
  'Música',
  'Sociales',
  'Tecnología',
  'Movimiento',
  'PBL',
  'STEM',
  'Numeracy',
  'Reading/Lectura',
  'Writing/Escritura',
  'Communication',
  'Performance',
];
